import { parsePhoneBeforeSend, matchISO } from 'helpers/parsePhone'
import { USA_ISO } from 'app/constants/phoneCountryCodes'

export const parseEmails = users => {
  if (typeof users === 'string') {
    return users
      .replace(/([\r\n])\1+/g, '\n')
      .trim()
      .split('\n')
  } else {
    throw new Error("only not empty 'string' type argument available")
  }
}

export function parseInvites(users) {
  if (typeof users === 'string' && users) {
    const parsedUsers = parseEmails(users)
    return parsedUsers.map(row => {
      let [email = null, firstName = null, lastName = null, phone = null, ...teams] = row
        .split(',')
        .map(value => value.trim())
      const parsedPhone = parsePhoneBeforeSend(phone)
      const phoneISO = matchISO(parsedPhone) || USA_ISO
      return {
        email: email.toLowerCase(),
        firstName,
        lastName,
        phone: parsedPhone,
        phoneISO,
        teams,
      }
    })
  } else {
    throw new Error("only not empty 'string' type argument available")
  }
}
